import { Injectable } from '@angular/core';
import { Filter, FilterValue } from '../search/filters/state/filter.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TypeaheadFiltersService {
  public isAimsKeywordFilterOpened$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  mapFilters(query: string, filters: Filter[]): Filter[] {
    const searchTerm = query.toLowerCase();
    return filters.filter(this.findFilters(searchTerm)).reduce((buffer: any, f: { max: any }) => {
      if (!searchTerm) {
        return [];
      }
      if (f.max) {
        return [].concat(buffer, [this.getMatchedSlider(searchTerm, f)]);
      }
      const matched = this.getMatched(searchTerm, f);
      const nextBuffer = [...buffer];
      const bufferUpdate = this.getFltten(matched, f);
      return [].concat(nextBuffer, bufferUpdate);
    }, []);
  }

  private findFilters(searchTerm: string): (f: Filter) => boolean {
    return (f: Filter) => {
      if (f.max || f.min) {
        if (Number.isInteger(parseInt(searchTerm, 10)) && f.max) {
          const numberValue = parseInt(searchTerm, 10);
          return numberValue >= f.min && numberValue <= f.max;
        }
        return false;
      }
      const hasMatch = f.values.filter((v: { name: string }) => {
        const name = v.name.toLowerCase();
        return name.startsWith(searchTerm);
      });
      return Boolean(hasMatch.length);
    };
  }

  private getMatched(searchTerm: any, filter: Filter): FilterValue[] {
    return filter.values.filter((v: { name: string; status: string }) => {
      const name = v.name.toLowerCase();
      return name.startsWith(searchTerm) && v.status === 'off';
    });
  }

  private getMatchedSlider(searchTerm: any, filter: Filter): { filter: Filter; value: any } {
    return {
      filter,
      value: {
        name: searchTerm,
        status: 'rangeIncludes',
      },
    };
  }

  private getFltten(matched: any[], filter: Filter): { filter: Filter; value: any }[] {
    return matched.map((match: any) => {
      const status = filter.name === 'country_control_percent' ? 'publishingIncludes' : 'includes';
      return {
        filter,
        value: { ...match, status },
      };
    });
  }
}
